var  formatStatus = function(iValue, iStates) {

  var fStates  = iStates.split(',');
  var fFormat  = "default";
  var fCaption = iValue;

  if(fStates[iValue]){
    fFormat = "default";
    var fState  = fStates[iValue].split('=');
    fCaption=fState[0];
    if(fState[1]){
      fFormat = fState[1];
    }
  }

  return "<span class='label label-"+fFormat+"'>"+fCaption+"</span>";
}
var  formatLoop = function(iValue, iCodebook, iFormat, iKey, iText) {
  var fResult = "";
  var fCodebook  = getArray(iCodebook);
  var fValue  = getArray(iValue);
  var fFormat = (iFormat)? iFormat : "{0}";
  
  for(var c=0; c<fValue.length; c++){
    var fV1 = fValue[c];

    for(i=0; i<fCodebook.length; i++){
      if(fV1==fCodebook[i][iKey]){
        fCaption = setReplace(fFormat, '{1}', fCodebook[i][iKey]);
        fCaption = setReplace(fFormat, '{0}', fCodebook[i][iText]);
        fResult += fCaption;
      }
    }
  }

  return fResult;	
}
var  getArray = function(iValue){
  if(Array.isArray(iValue)){
    return iValue
  }
  if(typeof(iValue)=='string'){
    return iValue.split(',');
  }
  if(typeof(iValue)=='object'){
    var fResult = [];
    for(var key in iValue){
      fResult.push(iValue[key]);
    }
    return fResult;
  }

  return [];
}
var  setReplace = function(iValue, iFrom, iTo) {
  return iValue.replace(iFrom, iTo);
}
var  formatLabel = function(iValue, iFormat, iCodebook, iText) {
  var fResult = "";
  var fLabes  = (Array.isArray(iValue))? iValue : iValue.split(',');
  var fFormat = (iFormat)? iFormat : 'default';

  for(i=0; i<fLabes.length; i++){
    var fCaption = fLabes[i];
    if((iCodebook)&&(iText)){
      fCaption = iCodebook[fCaption][iText];
    }
    
    fResult = fResult + "<span class='label label-"+fFormat+"'>"+fCaption+"</span> ";
  }

  return fResult;	
}
var  formatHtml = function(iValue, iDefault) {
  return iValue.replaceAll("\n", "<br>");
}  
var  formatText = function(iValue, iCodebook, iText, iDefault, iFormat) {
  var fResult = ((iDefault)? iDefault:"");
  var fLabes  = (Array.isArray(iValue))? iValue : iValue.split(',');
  var fFormat = (iFormat)? iFormat : 'default';

  for(i=0; i<fLabes.length; i++){
      var fCaption = fLabes[i];
      if((iCodebook)&&(iText)&&(iCodebook[iText])){
        fCaption = iCodebook[iText];
      }

      fResult =  "<span class='label label-"+fFormat+"'>"+fCaption+"</span> ";
  }

  return fResult;	
}
var  formatLabelG = function(iValue, iFormat, iMaxChar) {
  var fResult 	= "";
  var fLabesTmp = iValue.split(',');
  var fLabes  	= new Array();

  if((!iFormat)||(typeof iFormat=='undefined')) iFormat='default';

  for(i=0; i<fLabesTmp.length; i++) {
      var fLabeName = fLabesTmp[i];
      if(iMaxChar) fLabeName = fLabeName.substring(0, iMaxChar);
      fLabes[fLabeName] = (fLabes[fLabeName])? (fLabes[fLabeName]+1):1;
  }

  for(i in fLabes) {
    if(fLabes[i]>1)
      fResult = fResult + iFormat.replace('{{value}}', (fLabes[i]+'x '+i));
    else
      fResult = fResult + iFormat.replace('{{value}}', i);
  }

  return fResult;	
}
var format2 = function(iNumber) {
  if ((typeof iNumber==='undefined')||(iNumber==""))
      return "0.00";
      
  return parseFloat(parseFloat(iNumber).toFixed(2));
}
var formatMoney = function(iNumber) {
  if ((typeof iNumber==='undefined')||(iNumber==""))
      return "0.00";

  return parseFloat(iNumber).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
}
var formatSizeKB = function(iNumber) {

  if(iNumber){
    iNumber = parseFloat(iNumber / (1024));
    if(iNumber<1){
      return parseFloat(iNumber).toFixed(3).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    }else{
      return parseFloat(iNumber).toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    }
  }

  return "n/a";
}
var formatSizeMB = function(iNumber) {
  if ((typeof iNumber==='undefined')||(iNumber=="")){
    return "0";
  }else{
    iNumber = iNumber / (1024*1000);
  }

  return parseFloat(iNumber).toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
}
var formatBase64 = function(iValue, iDefault) {
  if ((typeof iValue==='undefined')||(iValue.trim()==""))
  {
      var iValue = "";

      if ((typeof iDefault!='undefined'))
          iValue = iDefault;
  }

  iValue = btoa(iValue);

  return iValue;
}
var formatSrc = function(iValue, iDefault) {
  if ((typeof iValue==='undefined')||(!iValue)||((iValue)&&(iValue.trim()=="")))
  {
      //var iValue = "/res/img/user_default.jpg";// /res/img/default.png";
      var iValue = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAA1BMVEX/TQBcNTh/AAAAAXRSTlMAQObYZgAAAApJREFUeJxjYgAAAAYAAzY3fKgAAAAASUVORK5CYII=';

      if ((typeof iDefault!='undefined'))
          iValue = iDefault;

      return iValue;
  }

  return iValue;
}
var formatSrcUser = function(iValue, iName) {
  if ((typeof iValue==='undefined')||(!iValue)||((iValue)&&(iValue.trim()=="")))
  {
      var iValue = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAA1BMVEX/TQBcNTh/AAAAAXRSTlMAQObYZgAAAApJREFUeJxjYgAAAAYAAzY3fKgAAAAASUVORK5CYII=';
      //var iValue = "//res.task4.me/img/user_default.jpg";// /res/img/default.png";

      if ((typeof iDefault!='undefined')){
        iValue = iDefault;
      }

      return iValue;
  }

  return iValue;
}
var formatTime = function(iValue, iNotUserDate) {
  if(typeof(iValue)==='undefined'){
    return "00:00";
  }
  if(!iValue||iValue===''){
    return "";
  }
  var fDate = new Date(iValue);
  if(iNotUserDate){

  }else{
    fDate = getUserDate(fDate);
  }
  var fMin 	= fDate.getMinutes();
  var fHour = fDate.getHours();
  var fTime = ((fHour<10)? '0':'') + fHour+':'+((fMin<10)? '0':'') + fMin;

  return fTime;
}
var formatTimeOld = function(iValue) {
  if(typeof(iValue)==='undefined'){
    return "0:00";
  }
  if(typeof(iValue)=="string"){
    return iValue.substring(11, 16);
  }

  var fMin 	= iValue.getMinutes();
  var fHour = iValue.getHours();
  var fTime = ((fHour<10)? '0':'') + fHour+':'+((fMin<10)? '0':'') + fMin;

  return fTime;
}
var formatTimeWork = function(iValue) {
  if ((typeof iValue==='undefined')||(iValue=="")){
    return "0:00";
  }

  var fEndDT = new Date();
  var fStartDT = new Date(iValue);
  var diffMs = (fEndDT-fStartDT); // milliseconds between now & Christmas
  var diffDays = Math.floor(diffMs / 86400000); 
  var diffHrs  = Math.floor((diffMs % 86400000) / 3600000);
  var diffMins = Math.floor(((diffMs % 86400000) % 3600000) / 60000); // minutes
  var diffSecs = Math.floor(diffMs / 1000 % 60);
  var fTime = "";
  if(diffMins<=1){
    fTime = diffSecs+"s";
  }else{
    if(0<diffDays){
      fTime += diffDays+"<small>d</small>";
    }
    if(0<diffHrs){
      fTime += diffHrs+"<small>h</small>";
      fTime += diffMins+"<small>m</small>";
    }else{
      fTime += diffMins+"<small>m</small>";
      fTime += diffSecs+"<small>s</small>";
    }
  }

  return fTime;
}
var formatDT = function(iValue) {
  if ((typeof iValue==='undefined')||(iValue==""))
      return "0:00";

  var fMin 	= parseFloat(iValue.substring(14, 16)).toFixed(0);
  var fHour = parseFloat(iValue.substring(11, 14)).toFixed(0);
  var fDate = '';
  fTime =((fHour<10)? '0':'') + fHour+':'+((fMin<10)? '0':'') + fMin;

  if( (iValue)&&(iValue.indexOf("-")>0) ) 
      fDate = iValue.substring(8, 10)+"."+iValue.substring(5, 7)+"."+iValue.substring(0, 4);

  return fTime+' '+fDate;
}
var getUserDate = function(iDate) {
  var fDate = new Date(iDate);

  if(Global&&Global.Session&&Global.Session.UserData&&Global.Session.UserData.Localization&&Global.Session.UserData.Localization.Timezone){
    fDate.setTime(fDate.getTime() + (Global.Session.UserData.Localization.Timezone*60*60*1000));
  }

  return fDate;
}
var formatAgo = function(iValue, iDefault) {
  if((typeof iValue==="undefined")||(iValue=="")||(!iValue)){
    if(iDefault){
      return iDefault;
    }else{
      return "";
    }
  }

  if(iValue=="0000-00-00 00:00:00"){
    return "(nema)";
  }
  if(typeof(iValue)=="string"){
    iValue = iValue.replace('T', ' ').substring(0, 18);
  }
  var today = new Date();
  var fDate = new Date(iValue);
  fDate = getUserDate(fDate);
  var diffMs = (today - fDate); 
  var diffDays = Math.floor(diffMs / 86400000);
  var diffHrs = Math.floor((diffMs % 86400000) / 3600000); 
  var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); 

  if((diffDays==0)&&(diffHrs==0)&&(diffMins<2)){
    var fStr = (SiteLng&&SiteLng.Format&&SiteLng.Format.AgoNow)? SiteLng.Format.AgoNow: 'upravo';
    return fStr;
  } 
  if((diffDays==0)&&(diffHrs==0)&&(diffMins<=59)) return "pre " + diffMins + ' minuta';
  if((diffDays==0)&&(diffHrs==1)&&(diffHrs<=24)) return "pre " + diffHrs + ' sata';
  if((diffDays==0)&&(diffHrs>=1)&&(diffHrs<=24)) return "pre " + diffHrs + ' sati';
  //if((diffDays==1)&&(diffHrs>=1)&&(diffHrs<=24)) return 24+diffHrs + ' hours ago';

  var fMin 	= parseFloat(iValue.substring(14, 16)).toFixed(0);
  var fHour = parseFloat(iValue.substring(11, 13)).toFixed(0);
  var fDate = '';
  fTime = ((fHour<10)? '0':'') + fHour+':'+((fMin<10)? '0':'') + fMin;

  if(diffDays==1) return fTime + ' juče';

  if( (iValue)&&(iValue.indexOf("-")>0) ) 
      fDate = iValue.substring(8, 10)+"."+iValue.substring(5, 7)+"."+iValue.substring(0, 4);

  return fTime+' '+fDate;
}
var formatFilter = function(iFilter, iNone, iWord) {
  var fResult = "";

  if(iWord){
    fResult += "Traži <b>"+iWord+"</b>";
  }

  for(var fKey in iFilter){

    if(fResult){
      fResult += "&nbsp;|&nbsp;";
    }

    var fValue = formatValue(iFilter[fKey].Value, iFilter[fKey].Meta.Control);

    if(fValue){
      fResult += fKey + '=' + fValue;
    }else{
      if(iFilter[fKey].Meta.Mandatory){
        fResult += fKey + '=<span class="text-danger"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></span>';
      }else{
        fResult += fKey + '=<span class="text-secondary"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></span>';
      }
    }
  }

  return (fResult)? fResult:iNone;
}
var formatValue = function(iValue, iControl) {
  if ((typeof(iValue)==='undefined')||(iValue=="")){
    return "";
  }

  var fValue = iValue;
  if(iControl)
  {
    switch(iControl.toString().toLowerCase())
    {
      case "date":
        if(iValue){
          if(iValue.endsWith(" 00:00:00")) iValue.replace(" 00:00:00", "");
          if(iValue.endsWith("T00:00:00")) iValue.replace("T00:00:00", "");
        
          if(iValue.indexOf("-")>0){
            fDate = iValue.substring(8, 10)+"."+iValue.substring(5, 7)+"."+iValue.substring(0, 4);
          }
                    
          fValue = fDate;  
        }
      break;
      case "time":
        if(10<fValue.length){
          fValue = fValue.substring(11, 16);
        }
      break;
      case "checkbox":
        fValue = (fValue=="1"||fValue.toString().toLowerCase()=="true")? "Da":"Ne";
      break;
      case "money":
        try{
          fValue = new Intl.NumberFormat('sr-RS', { style: 'currency', currency: 'RSD', minimumFractionDigits: 2 }).format(fValue);
          fValue = fValue.replace('RSD', '');
          fValue = fValue.replace('&nbsp;', '');
        }catch(err){

        }        
      break;      
      case "datetime":
        try{
          fValue = new Date(fValue).toLocaleString('sr-RS', { timeZone: 'UTC' });
        }catch(err){

        }        
      break;      
    }
  }

  return fValue;
}
var formatKey = function(iRow, iMeta, iDefault){
  if(iMeta&&iRow&&iMeta.Columns){
    var fCaption = "";
    for (let i = 0; i < iMeta.Columns.length; i++) {
      if((iMeta.Columns[i].IsKey)&&(iMeta.Columns[i].Name)&&(iRow[iMeta.Columns[i].Name])){
        fCaption += iRow[iMeta.Columns[i].Name].toString() + "&nbsp;";
      }
    }

    return fCaption;
  }

  return (iDefault)? iDefault:"";
}
var formatCaption = function(iRow, iMeta, iDefault){
  if(iRow&&iRow.sysrownew){
    return '<span class="text-info">NOVO</span>';
  }
  if(iMeta&&iRow&&iMeta.Columns){
    var fKey = "";
    var fCaption = "";
    for (let i = 0; i < iMeta.Columns.length; i++) {
      /*if((iMeta.Columns[i].fieldkey=="true")&&(iMeta.Columns[i].fieldname)&&(iRow[iMeta.Columns[i].fieldname])){
        fKey += iRow[iMeta.Columns[i].fieldname].toString() + "&nbsp;";
      }*/
      if((iMeta.Columns[i].IsCaption)&&(iMeta.Columns[i].Name)&&(iRow[iMeta.Columns[i].Name])){
        let fValue = iRow[iMeta.Columns[i].Name].toString();
        if(fValue){
          fCaption += formatValue(fValue, iMeta.Columns[i].Control) + "&nbsp;";
        }else{
          fCaption += "&nbsp;";
        }
      }
    }
    return fCaption;
    return fKey + ((fCaption)? (" - " + fCaption):"");
  }

  return (iDefault)? iDefault:"";
}
var formatFormat = function(iValue, iMeta, iDefault){
  if(iValue&&iMeta){
    var fCaption = iValue;
    for(var fKey in iMeta) {
      if(iMeta[fKey]&&iMeta[fKey].Value){
        fCaption = fCaption.replace("{"+fKey+"}", iMeta[fKey].Value.toString());
      }else{
        fCaption = fCaption.replace("{"+fKey+"}", iMeta[fKey].toString());
      }
    }
    return fCaption;
  }

  return (iDefault)? iDefault:"";
}
var formatDate = function(iValue, iDefault) {
  if ((typeof iValue==='undefined')||(iValue=="")){
    return (iDefault)? iDefault.toString():"";
  }

  if(iValue){
    try{
      const options = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      };
      let fDate;
      if(typeof iValue==='Date'){
        fDate = iValue.toLocaleDateString('sr-RS', options);
      }
      if(typeof iValue==='string'){
        fDate = new Date(iValue).toLocaleDateString('sr-RS', options);        
      }
    
      if(fDate){
        return fDate;
      }
    }catch(err){
  
    }  
  }

  return (iDefault)? iDefault:"";
}
var formatDateDay2 = function(iValue, iDefault) {
  if ((typeof iValue==='undefined')||(iValue=="")){
    return (iDefault)? iDefault.toString():"";
  }

  if(iValue){
    try{
      let fDate;
      if(typeof iValue==='Date'){
        fDate = iValue;
      }
      if(typeof iValue==='string'){
        fDate = new Date(iValue);
      }
    
      if(fDate){
        return fDate.getDate();
      }
    }catch(err){
  
    }  
  }

  return (iDefault)? iDefault:"";
}
var formatDateDayName = function(iValue, iDefault) {
  if ((typeof iValue==='undefined')||(iValue=="")){
    return (iDefault)? iDefault.toString():"";
  }

  if(iValue){
    try{
      let fDate;
      if(typeof iValue==='Date'){
        fDate = iValue;
      }
      if(typeof iValue==='string'){
        fDate = new Date(iValue);
      }
    
      if(fDate){
        let fDay = fDate.getDay();
        let fDayName = "";
        switch(fDay){
          case 0: fDayName = "NED"; break;
          case 1: fDayName = "PON"; break;
          case 2: fDayName = "UTO"; break;
          case 3: fDayName = "SRE"; break;
          case 4: fDayName = "ČET"; break;
          case 5: fDayName = "PET"; break;
          case 6: fDayName = "SUB"; break;
        }
        return fDayName;
      }
    }catch(err){
  
    }  
  }

  return (iDefault)? iDefault:"";
} 
var formatDateLong = function(iValue, iDefault) {
  if(iValue){
    try{
      const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      };
      let fDate;

      if(typeof iValue==='object'){
        fDate = iValue.toLocaleDateString('sr-RS', options);
      }
      if(typeof iValue==='string'){
        fDate = new Date(iValue).toLocaleDateString('sr-RS', options);        
      }
    
      if(fDate){
        return fDate;
      }
    }catch(err){
      
    }    
  }
  return (iDefault)? iDefault:"";
}
var formatColor = function(iValue, iColor){
    if(iColor){
      return iColor;
    }
    if(iValue){
      if(iValue=='0'){
        return '#d9534f';
      }
      if(iValue=='1'){
        return '#02B875';
      }
      var hash = 0;

      for (var i = 0; i < iValue.length; i++) {
        hash = iValue.charCodeAt(i) + ((hash << 5) - hash);
      }

      return (hash & 0x00FFFFFF).toString(16).toUpperCase();
    }

    return "#00000";
}
var formatBackMedia = function(iValue){
  if(!iValue){
    return;
  }
  var fValue = iValue;
  var fHtml = '';
  var fVidback = '<video autoplay muted loop style="position: fixed;right: 0;bottom: 0;min-width: 100%;min-height: 100%;"><source src="{{link}}" type="video/mp4"></video>';
  var fYTback = '<div class="hidden-xs video-background" style="position: fixed; top: 0; right: 0; bottom: 0; left: 0; z-index: -100;"><iframe id="bckvideo" type="text/html" frameborder="0" height="100%" width="100%"   src="{{link}}"  allowfullscreen></iframe></div>';
  var fImgback = '<style>body { background-image: url({{link}}); }</style>';
  
  if(Array.isArray( iValue)){
    var bckList = iValue;
    var rnd = Math.floor(Math.random() * bckList.length);
    fValue = iValue[rnd];
}

  if((fValue)&&(fValue!="")){
    if(fValue.indexOf('youtube') !== -1){
      fValue = formatYTBack(fValue);
      fHtml = fYTback.replace('{{link}}', fValue);
      //var myVideo =  iframe.getElementById('myVideo'); 
      //myVideo.mute();
    }else{
      if(fValue.indexOf('.mp4') !== -1){
        fHtml = fVidback.replace('{{link}}', fValue);
      }else{
        fHtml = fImgback.replace('{{link}}', fValue);
      }
    }
  }

  return fHtml;
}
var formatYTBack = function(iValue){

  var fValue = iValue;
  var n = fValue.indexOf("?");
  var fVideoUrl = iValue;//(n)? fValue.substring(0, n):fValue;
  var fSplit = fValue.split('&');
  var fParams = "?rel=0&enablejsapi=1&autoplay=1&controls=0&showinfo=0&loop=1&iv_load_policy=3&mute=1";
  //rel=0&enablejsapi=1&autoplay=1&controls=0&showinfo=0&loop=1&iv_load_policy=3&mute=1&list=PL7jzVA9xYSRg8Xd2VXqV5QVVqfghuhuHI&index=5
  fVideoUrl = fVideoUrl+fParams;

  for(var i=1;i<fSplit.length; i++){
    var fKey = fSplit[i];
    var fKeyName = fKey.split('=')[0];
    if(fParams.indexOf(fKeyName)==-1){
      fVideoUrl = fVideoUrl+'&'+fKey;
    }
  }

  return fVideoUrl;
}
var MessageShow = function(iMessage, iFullName, iProfilePicture){

  var fMessageText='';
  var fMessageTitle='';
  var fMessagePicture='';

  if(iMessage.Text){
    fMessageText=iMessage.Text;
  }

  if(iMessage.Type)
    fMessageTitle=iMessage.Type;
  
  if (!("Notification" in window)) {
    console.log("This browser does not support desktop notification!");
  }
  else if (Notification.permission === "granted") {
    var options = {
        body: fMessageText,
        icon: fMessagePicture
    }
    var notification = new Notification(fMessageTitle, options);
    setTimeout(notification.close.bind(notification), 5000);
  }
  else if (Notification.permission !== 'denied') {
    Notification.requestPermission(function (permission) {
      if (permission === "granted") {
        var notification = new Notification(fMessageText);
      }
    });
  }
} 
var getCount = function (iValue){
  if(typeof(iValue)=="string"){
    return 0;
  }
  if(iValue){
    if(Array.isArray(iValue)) {
      return iValue.length;
    }else{
      var i=0;
      for(var key in iValue){
        i++;
      }
      return i;
    }
  }

  return 0;
}
var getBase64 = function (iValue) {
  if(iValue){
    try
    {
      var fValue = JSON.stringify(iValue);

      fValue = unescape(encodeURIComponent(fValue));
      fValue = btoa(fValue).toString().replace('==', '').replace('=', '').trim();
    
      return fValue;  
    }
    catch(err){

    }
  }

  return '';
}
var isEmpty = function(iValue) {
  if(typeof iValue==="undefined"){
    return true;
  }

  if((iValue)&&(iValue=="")){
    return true;
  }

  return !(iValue);
}
var isNotEmpty = function(iValue) {
  if(typeof iValue==="undefined"){
    return false;
  }

  if((iValue)&&(iValue=="")){
    return false;
  }

  return ((iValue)&&(iValue!=""));
}
var formatOnline = function(iUserUID) {
  if((Global)&&(Global.Users)&&(Global.Users.Online)&&(typeof Global.Users.Online[iUserUID]!='undefined')){
    return 'online';
  }

  return 'off';
}
var formatHref = function(iPage, iUID, iData) {  
  var fHref="#";
  if(iPage){
    fHref += iPage;
  }  
  if(iUID){
    fHref += "/" + iUID;
  }  
  if(iData){    
    fHref += "?"+btoa(encodeURIComponent(JSON.stringify(iData)));
  }

  return fHref;
}
var formatIsUser = function(){
  if(Global&&Global.Session&&Global.Session.Status){
    return Global.Session.Status;
  }

  return false;
}
var formatFirstName = function(iValue, iDefault){
  var fRez = "";
  var fValue = "";
  if(iValue){
    fValue = iValue;
  }else{
    if(Global&&Global.Session&&Global.Session.UserData&&Global.Session.UserData.FullName){
      fValue = Global.Session.UserData.FullName;
    }
  }
  
  if(fValue){
    var fNm = fValue.split(' ');
    if(fNm&&0<fNm.length){
      fRez = fNm[0];
    }
  }else{
    fRez = (iDefault)? iDefault:"Anonimus";
  }

  
  return fRez;
}
var formatLastName = function(iValue, iDefault){
  var fRez = "";
  var fValue = "";

  if(iValue){
    fRez = iValue;
  }else{
    if(Global&&Global.Session&&Global.Session.UserData&&Global.Session.UserData.FullName){
      var fNm = Global.Session.UserData.FullName.split(' ');
      if(fNm&&1<fNm.length){
        fRez = fNm[1];
      }
    }else{
      fNm = (iDefault)? iDefault:"Anonimus";
    }
  }
  
  return fRez;
}
var formatXml2Json = function(iValue, iDefault){
  if(!iValue){
    return (iDefault)? iDefault:{};
  }
  let json = {};
  function parseXmlToJson(xml) {
    let json = {};
    let arr = [];
    for (const res of xml.matchAll(/(?:<(\w*)(?:\s[^>]*)*>)((?:(?!<\1).)*)(?:<\/\1>)|<(\w*)(?:\s*)*\/>/gm)) {
        const key = res[1] || res[3];
        const value = res[2] && parseXmlToJson(res[2]);
        json[key] = ((value && Object.keys(value).length) ? value : res[2]) || null;
        let frow = ((value && Object.keys(value).length) ? value : res[2]) || null;
        arr.push(frow);
    }
    return arr;
  }
  json = parseXmlToJson(iValue);
  
  return json;
}
var formatTable = function(iValue){
  if(iValue&&iValue!='<Security />'){
    const myJson = formatXml2Json(iValue);
    return (myJson&&0<myJson.length)? myJson[0]:[];
  }

  return [];
}
var formatIsMySmena = function(iSmena1, iSmena2){
  /*console.log('formatIsMySmena', iSmena1, iSmena2);*/
  if(iSmena1&&iSmena2){
    if(0==iSmena1.toString().indexOf(iSmena2.toString())){
      return true;
    }
    if(0==iSmena2.toString().indexOf(iSmena1.toString())){
      return true;
    }

    return false;
  }

  return true;
}

module.exports.formatTable = formatTable;
module.exports.formatXml2Json = formatXml2Json;
module.exports.formatSrc = formatSrc;
module.exports.formatSrcUser = formatSrcUser;
module.exports.formatValue = formatValue;
module.exports.formatDT = formatDT;
module.exports.formatAgo = formatAgo;
module.exports.formatDate = formatDate;
module.exports.formatDateLong = formatDateLong;
module.exports.formatTime = formatTime;
module.exports.formatTimeWork = formatTimeWork;
module.exports.getBase64 = getBase64;
module.exports.getCount = getCount;
module.exports.formatStatus = formatStatus;
module.exports.formatColor = formatColor;
module.exports.formatMoney = formatMoney;
module.exports.formatLoop = formatLoop;
module.exports.formatLabel = formatLabel;
module.exports.formatText = formatText;
module.exports.formatYTBack = formatYTBack;
module.exports.formatHtml = formatHtml;
module.exports.formatCaption = formatCaption;
module.exports.isEmpty = isEmpty;
module.exports.isNotEmpty = isNotEmpty;
module.exports.formatIsUser = formatIsUser;
module.exports.formatFirstName = formatFirstName;
module.exports.formatLastName = formatLastName;
module.exports.Href = formatHref;
module.exports.format= {
  IsMySmena: formatIsMySmena,
  Table: formatTable,
  Src: formatSrc,
  SrcUser: formatSrcUser,
  Filter: formatFilter,
  Value: formatValue,
  Key: formatKey,
  Caption: formatCaption,
  Format: formatFormat,
  DT: formatDT,
  Ago: formatAgo,
  Date: formatDate,
  DateLong: formatDateLong,
  DateDay2: formatDateDay2,
  DateDayName: formatDateDayName,
  Time: formatTime,
  Base64: getBase64,
  Status: formatStatus,
  Color: formatColor,
  Money: formatMoney,
  SizeKB: formatSizeKB,
  SizeMB: formatSizeMB,
  Loop: formatLoop,
  Label: formatLabel,
  Text: formatText,
  Email: function(iValue){
    return iValue;
  },
  YTBack: formatYTBack,
  Html: formatHtml,
  Caption: formatCaption,
  isEmpty: isEmpty,
  isNotEmpty: isNotEmpty,
  IsUser: formatIsUser,
  FirstName: formatFirstName,
  LastName: formatLastName,
  Count: getCount,
  Online: formatOnline,
  Href: formatHref,
  BackMedia: formatBackMedia,
  Array: getArray,
  isSame: function(iNew, iOld){
    if(iNew&&iOld&&(iNew==iOld)){
      return true;
    }
    if(iNew&&iOld&&(JSON.stringify(iNew)==iOld)){
      return true;
    }
    if(iNew&&iOld&&(JSON.stringify(iNew)==JSON.stringify(iOld))){
      return true;
    }
    return false;
  }
}


//////////////////
// WEBPACK FOOTER
// ./ractive/Project/ERP/format.js
// module id = 10
// module chunks = 0